// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';

// Project Imports
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import Loading from 'components/loading/loading';

const ImageUploadList = lazy(
  () => import('pages/categoryManagement/productImageUpload/imageUploadList')
);

const ImageUploadCreate = lazy(
  () => import('pages/categoryManagement/productImageUpload/imageUploadCreate')
);
const ImageUploadEdit = lazy(
  () => import('pages/categoryManagement/productImageUpload/imageUploadEdit')
);
const ImageUploadShow = lazy(
  () => import('pages/categoryManagement/productImageUpload/imageUploadShow')
);

const UploadProductImageRoute = (
  <Route path={routeName.uploadProductImage}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.UPLOAD_PRODUCT_IMAGE_VIEW,
            PrivateRouteConst.SELF_UPLOAD_PRODUCT_IMAGE_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <ImageUploadList />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="create"
      element={
        <PrivateRoute name={PrivateRouteConst.CREATE_UPLOAD_PRODUCT_IMAGE}>
          <Suspense fallback={<Loading />}>
            <ImageUploadCreate />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="edit/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.UPLOAD_PRODUCT_IMAGE_EDIT,
            PrivateRouteConst.SELF_UPLOAD_PRODUCT_IMAGE_EDIT,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <ImageUploadEdit />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.UPLOAD_PRODUCT_IMAGE_VIEW,
            PrivateRouteConst.SELF_UPLOAD_PRODUCT_IMAGE_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <ImageUploadShow />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default UploadProductImageRoute;
